import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ paddingTop: 80, paddingBottom: 80, minHeight: "100vh" }}>
      <div className="container" style={{ maxWidth: 900 }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 32 }}>Privacy Policy</h1>
        <div style={{ lineHeight: 1.8, color: "#c0c0e0" }}>
          
          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>1. Introduction</h2>
          <p>Ariyom Tech Solutions ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our internship platform and website.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>2. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you register for our internship program:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>College/University Name</li>
            <li>Department and Year of Study</li>
            <li>Domain of Interest</li>
            <li>GitHub and LinkedIn Profiles</li>
            <li>Payment Information (transaction ID, payment screenshots)</li>
          </ul>
          <p style={{ marginTop: 12 }}>We may also automatically collect usage information such as IP address, browser type, pages visited, and timestamps.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>3. How We Use Your Information</h2>
          <p>We use your information for the following purposes:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>To process your internship registration and payments</li>
            <li>To send you course materials, assignments, and updates</li>
            <li>To issue certificates upon completion</li>
            <li>To track your progress and provide feedback</li>
            <li>To communicate with you about your internship status</li>
            <li>To improve our platform and services</li>
            <li>To comply with legal and regulatory requirements</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>4. Data Security</h2>
          <p>We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, and disclosure. However, no method of transmission over the internet is 100% secure. We cannot guarantee absolute security of your data.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>5. Third-Party Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. However, we may share your information with:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>Payment processors (PhonePe) to process your payments</li>
            <li>Service providers who assist us in operating our website</li>
            <li>Law enforcement if required by legal process</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>6. Cookies</h2>
          <p>Our website uses cookies to enhance your user experience. You can control cookie settings in your browser. However, disabling cookies may affect your ability to use certain features of our platform.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>7. Your Rights</h2>
          <p>You have the right to:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>Access your personal information</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data (subject to legal retention requirements)</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>8. Data Retention</h2>
          <p>We retain your personal information for as long as necessary to provide our services and comply with legal obligations. After completion of your internship, we may retain your data for archival and record-keeping purposes.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>9. Children's Privacy</h2>
          <p>Our platform is not intended for individuals under 18 years of age. We do not knowingly collect personal information from children. If we learn we have collected personal information from a child, we will delete such information immediately.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>10. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. When we do, we will post the updated policy on this page with an updated "Last Updated" date. Your continued use of our platform constitutes your acceptance of the updated policy.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>11. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our privacy practices, please contact us:</p>
          <p style={{ marginTop: 12 }}>
            <strong>Email:</strong> support@ariyomtechsolutions.site<br />
            <strong>Website:</strong> ariyomtechsolutions.site<br />
            <strong>Address:</strong> India
          </p>

          <p style={{ marginTop: 32, fontSize: 13, color: "#555" }}>Last updated: May 18, 2026</p>
        </div>
      </div>
    </div>
  );
}
